
import { defineComponent, toRefs, reactive, computed } from 'vue'
import Heart from '@/components/Icons/Heart.vue'
import ProgressBar from '@/pages/Challenges/components/ProgressBar.vue'

export default defineComponent({
  name: 'Timer',
  components: { Heart, ProgressBar },
  props: {
    percentile: {
      type: Number,
      required: true,
    },
    display: {
      type: String,
      required: true,
    },
    points: {
      type: Number,
      required: true,
    },
    currentLives: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      lives: computed(() =>
        new Array(props.currentLives).fill('').map(Math.random)
      ),
    })

    return toRefs(state)
  },
})
